import { createSlice } from "@reduxjs/toolkit";

export const cardData = createSlice({
  name: "card_data",
  initialState: {
    getcardData: [],
  },
  reducers: {
    onSavePoints: (state, { payload }) => {
      if (payload?.points !== undefined) {
        state.points = Math.round(payload.points);
      }
      if (payload?.pointBalance !== undefined) {
        state.pointBalance = Math.round(payload.pointBalance);
      }
      if (payload?.identifierType !== undefined) {
        state.identifierType = payload.identifierType;
      }
      if (payload?.subIdentifier !== undefined) {
        state.subIdentifier = payload.subIdentifier;
      }
    },
    onSaveCredsGet: (state) => {
      return {
        ...state,
        accessKey: "",
        integrationSecretKey: "",
        secrateKey: "",
        SignInUrl: "",
        partnerCode: "",
        ClientCode: "",
        integrationId: "",
        partnerCodeBody: "",
      };
    },
    onSaveCreds: (state, { payload }) => {
      const {
        ClientCode,
        SignInUrl,
        accessKey,
        integrationSecretKey,
        partnerCode,
        secrateKey,
        integrationId,
        partnerCodeBody,
        redemptionPartnerCode,
        integrationPartnerCode,
        smsCode,
      } = extractVariables(payload?.data);
      return {
        ...state,
        accessKey,
        integrationSecretKey,
        secrateKey,
        SignInUrl,
        partnerCode,
        ClientCode,
        integrationId,
        partnerCodeBody,
        redemptionPartnerCode,
        integrationPartnerCode,
        smsCode,
      };
    },
    onSaveCredsError: (state, { payload }) => {
      return {
        ...state,
        accessKey: "",
        integrationSecretKey: "",
        secrateKey: "",
        SignInUrl: "",
        partnerCode: payload?.partnerCode,
        ClientCode: payload?.ClientCode,
        integrationId: payload?.integrationId,
      };
    },
    onSaveOrderData: (state, { payload }) => {
      return {
        ...state,
        OrderData: payload,
      };
    },
    onShowThankYou: (state) => {
      return {
        ...state,
        show: true,
      };
    },
    onShowThankYouReset: (state) => {
      return {
        ...state,
        show: false,
      };
    },
    onShowFailure: (state) => {
      return {
        ...state,
        failure: true,
      };
    },
    onShowFailureReset: (state) => {
      return {
        ...state,
        failure: false,
      };
    },
    onSaveDenoCard: (state, { payload }) => {
      return {
        ...state,
        productData: payload?.productData,
        orderId: payload?.orderId,
        orderNumber: payload?.orderNumber,
        denomination: payload?.denomination,
      };
    },
    onSaveDenoCardReset: (state, { payload }) => {
      return {
        ...state,
        productData: null,
        orderId: null,
        orderNumber: null,
        denomination: null,
      };
    },
    onSaveLimitDetails: (state, { payload }) => {
      // handleLimit dispatches on every quantity change; keep the same state
      // reference when nothing changed so subscribers and persist skip work.
      if (
        payload &&
        typeof payload === "object" &&
        Object.keys(payload).every((key) => state[key] === payload[key])
      ) {
        return state;
      }
      return {
        ...state,
        ...payload,
      };
    },
  },
});

export function extractVariables(data) {
  const result = {};

  const signInUrl = data?.find((item) => item.url !== "");
  if (signInUrl) {
    result.SignInUrl = signInUrl.url;
  }

  data?.forEach((item) => {
    if (item.isParam && item.paramsKey && item.paramsValue) {
      result[item.paramsKey] = item.paramsValue;
    }
  });

  return result;
}

export const {
  onSavePoints,
  onSaveCreds,
  onSaveCredsGet,
  onSaveCredsError,
  onSaveOrderData,
  onShowThankYou,
  onShowThankYouReset,
  onShowFailure,
  onShowFailureReset,
  onSaveDenoCard,
  onSaveDenoCardReset,
  onSaveLimitDetails,
} = cardData.actions;

export default cardData.reducer;
